export {
  ATTESTED_DOCUMENT,
  attestedDocumentKey,
  THEME,
  GROUP_THEME,
  themeKey,
  groupThemeKey,
  PORTAL_CONTEXT,
  portalContextKey,
  SERVICE_CATALOGUE,
  serviceCatalogueKey,
  SCHOOL_FEE_STUDENT_SEARCH,
  SCHOOL_FEE_CATALOGUE,
  SCHOOL_FEE_FEE_ASSIGNMENT,
  schoolFeeStudentSearchKey,
  schoolFeeCatalogueKey,
  schoolFeeFeeAssignmentKey,
} from "./query";

export {
  LAPSED_SESSION_CODE,
  SCHOOL_FEE_ERROR_CODES,
  SHARED_PAY_ERROR_CODES,
  JOURNEY_NEUTRAL_ERROR_CODES,
  ERROR_DECISIONS,
  errorDecision,
} from "./errorDecisions";
export type {
  ErrorDecision,
  ErrorDecisionState,
  ErrorWaiver,
} from "./errorDecisions";

export { DEFAULT_SERVICE_LOGO, swapToDefaultServiceLogo } from "./serviceLogo";

export const TRANSACTION_STATUS = {
  success: "SUCCESS",
  pending: "PENDING",
  errored: "ERRORED",
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
